import { render, staticRenderFns } from "./RequestCompleted.vue?vue&type=template&id=3e70167a&scoped=true&"
import script from "./RequestCompleted.vue?vue&type=script&lang=ts&"
export * from "./RequestCompleted.vue?vue&type=script&lang=ts&"
import style0 from "./RequestCompleted.vue?vue&type=style&index=0&id=3e70167a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e70167a",
  null
  
)

export default component.exports